var map = {
	"./alipay.png": "4VwE",
	"./all_channel_pay.png": "2w38",
	"./app_banner.png": "KDze",
	"./app_front_mobile.png": "NDUT",
	"./app_instant_flow.png": "YCSe",
	"./app_master.png": "fdXD",
	"./app_mso.png": "+feW",
	"./app_online_income.png": "fr5S",
	"./app_payment_link.png": "yP0J",
	"./app_pci_level.png": "a839",
	"./app_swift.png": "xeAo",
	"./app_unionpay.png": "XIoe",
	"./app_visa.png": "wo7j",
	"./applePay.png": "kegB",
	"./bg_line.png": "X1z9",
	"./blog_banner.png": "ufel",
	"./blog_detail_1.png": "Dp9p",
	"./blog_detail_2.png": "aFWX",
	"./blog_good_1.png": "qhuf",
	"./blog_good_10.png": "qYLB",
	"./blog_good_11.png": "6Idn",
	"./blog_good_12.png": "5ggc",
	"./blog_good_2.png": "0GkI",
	"./blog_good_3.png": "PL9S",
	"./blog_good_4.png": "i2Ta",
	"./blog_good_5.png": "MxeV",
	"./blog_good_6.png": "2ifa",
	"./blog_good_7.png": "7VaQ",
	"./blog_good_8.png": "huLW",
	"./blog_good_9.png": "++Mp",
	"./blog_new_1.png": "OaOS",
	"./blog_new_2.png": "gLoz",
	"./blog_new_3.png": "9Klt",
	"./circlePay.png": "L6cx",
	"./console_banner.png": "Tg8z",
	"./console_finance_report.png": "1aqh",
	"./console_order_list.png": "wTDy",
	"./console_trade_inspect.png": "sUiF",
	"./contact_bg.png": "ccR/",
	"./discoverPay.png": "ecdM",
	"./divide_line.png": "bmMY",
	"./download_account_mobile.png": "E0lI",
	"./download_android.png": "GsHP",
	"./download_ios.png": "wffM",
	"./download_merchant_mobile.png": "3rZc",
	"./download_user_mobile.png": "jDX4",
	"./facebook.png": "9OZz",
	"./gpay.png": "eMxN",
	"./home_bg.png": "I/ig",
	"./home_bg_all.png": "3GzW",
	"./hua_yu_jie_logo.png": "lCpu",
	"./ins.png": "HH6i",
	"./jcbPay.png": "6koq",
	"./lg.png": "4kjZ",
	"./lips_tea_logo.png": "yWUo",
	"./logo.png": "3nbq",
	"./logo_butterfly.png": "+dm6",
	"./logo_product.png": "X4xR",
	"./logo_white.png": "CABr",
	"./meet_nuddle_logo.png": "NJHx",
	"./merchant_banner.png": "jBCI",
	"./merchant_case_1.png": "hVaj",
	"./merchant_case_2.png": "GQF8",
	"./merchant_case_3.png": "wkNP",
	"./merchant_case_4.png": "wFpy",
	"./merchant_case_5.png": "oXkt",
	"./merchant_case_6.png": "/b9y",
	"./merchant_detail_banner.png": "Ouje",
	"./merchant_detail_video.png": "JdQ5",
	"./merchant_feature_1.png": "MGef",
	"./merchant_feature_10.png": "Xn/G",
	"./merchant_feature_11.png": "YqAo",
	"./merchant_feature_12.png": "5eiB",
	"./merchant_feature_2.png": "KiYp",
	"./merchant_feature_3.png": "sjwR",
	"./merchant_feature_4.png": "lD+q",
	"./merchant_feature_5.png": "xn5I",
	"./merchant_feature_6.png": "81y6",
	"./merchant_feature_7.png": "mqoB",
	"./merchant_feature_8.png": "we5/",
	"./merchant_feature_9.png": "aAiU",
	"./merchant_new_1.png": "KvlM",
	"./merchant_new_2.png": "UsJs",
	"./merchant_new_3.png": "N7mg",
	"./order_list.png": "LMsW",
	"./pay_connect.png": "Xx/u",
	"./paygateway.png": "TYQW",
	"./payment_detail.png": "HLmI",
	"./pos_banner.png": "z26x",
	"./pos_bg.png": "8VoF",
	"./pos_im.png": "MYsH",
	"./pos_machine.png": "DloI",
	"./pos_machine_icon.png": "oKmV",
	"./pos_multiple_device.png": "epOs",
	"./pos_order_list2.png": "lg5T",
	"./pos_pay_button.png": "WGUH",
	"./pos_pay_detail2.png": "70OF",
	"./pos_pay_info.png": "QK4B",
	"./pos_pay_machine.png": "qDO/",
	"./pos_product_income.png": "SjE3",
	"./pos_product_qrcode.png": "uSsv",
	"./pos_qrcode.png": "WIx0",
	"./pos_qrcode2.png": "rnLI",
	"./price_banner.png": "8to8",
	"./rice_line_logo.png": "/wQT",
	"./sample_mobile.png": "Jh7M",
	"./tai_xing_logo.png": "/v44",
	"./three_bro_logo.png": "DbJa",
	"./two_in_one_pos.png": "Ir4/",
	"./uu.png": "jRNy",
	"./visaPay.png": "w4gV",
	"./why_us_channel.png": "b7mJ",
	"./x.png": "4oVY",
	"./yandexPay.png": "Y8aa",
	"./yijia_log.png": "Yziu",
	"./z_pay_case.png": "rVS7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FXAF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images ^\.\/.*\.png$
// module id = FXAF
// module chunks = 8